import { call, put, takeLatest } from "redux-saga/effects";
import curry from "lodash/fp/curry";

import { rsf } from "../../../init/firebase";
import chatActionCreators from "../../actions/chat";
import { isLoading, setRooms, syncRooms } from "../../reducers/chat";
import { ChatType } from "../../../enums";
import { modifiedPreparedRooms } from "../../../utils/chat";
import { getChatRoomsQuery } from "../../../queries/chatRooms";
import { roomDocRef } from "../../../utils/refrences.utils";

const finalQuery = curry((isLast, lastDocSnapshot, query) => {
  let newQuery;
  if (isLast && lastDocSnapshot) {
    newQuery = query.startAfter(lastDocSnapshot).limit(20);
  } else {
    newQuery = query.limit(20);
  }
  return newQuery;
});

function* getPropertyRooms(action) {
  const { companyId, userId, role, last } = action.payload;

  let lastDocSnapshot;
  if (last) {
    lastDocSnapshot = yield roomDocRef(last.id).get();
  }

  const finalQueryWithLast = finalQuery(last)(lastDocSnapshot);
  const propertyQuery = finalQueryWithLast(getChatRoomsQuery(ChatType.property, companyId, userId, role));

  try {
    yield put(isLoading({ type: ChatType.property, loading: true }));
    const propertySnapshot = yield call(rsf.firestore.getCollection, propertyQuery);
    const preparedRooms = yield modifiedPreparedRooms(propertySnapshot.docs);
    yield put(
      last
        ? syncRooms({ rooms: preparedRooms, chatType: ChatType.property })
        : setRooms({ rooms: preparedRooms, chatType: ChatType.property })
    );
    yield put(isLoading({ type: ChatType.property, loading: false }));
  } catch (ex) {
    console.log(ex.message);
    yield put(isLoading({ type: ChatType.property, loading: false }));
  }
}

export function* watchGetPropertyRooms() {
  yield takeLatest(chatActionCreators.getPropertyRooms.toString(), getPropertyRooms);
}
